import React from 'react'
import './Component1.css'
import { Col, Row } from 'react-bootstrap'

const Component1 = ({title1,title2,title3,imgSrc}) => {
    return (
      <div className="hero_block">
        <Row className="align-items-flex-start">
          <Col lg={6} md={12} className="order-lg-1 order-2">
            <h2 className="heading_title">
              {title1} <br /> {title2}
            </h2>
            <p className="paragraph">{title3}</p>
          </Col>

          <Col lg={6} className="order-lg-2 order-1">
            <div className="image_wrapper">
              <img
                src={process.env.PUBLIC_URL + imgSrc}
                alt="Car Maintenance"
                className="hero_img img-fluid"
              />
            </div>
          </Col>
        </Row>
      </div>
    );
}

export default Component1